import React from 'react'
import IconButton from 'srcReact/components/common2/IconButton'
import styles from './styles.module.scss'

function WidgetContainer({ children, className, title, subTitle, imageName, showMoreLabel, handleShowMore }) {
  return (
    <div className={`${styles.widgetContainer} ${className}`}>
      {title && <h1 className={styles.title}>{title}</h1>}
      {subTitle && <h2 className={styles.subTitle}>{subTitle}</h2>}
      <div className={styles.body}>{children}</div>
      {(imageName || showMoreLabel) && (
        <div className={styles.footer}>
          {imageName && <div className={`${styles.image} ${styles[imageName]}`}></div>}
          {showMoreLabel && (
            <IconButton
              iconName='arrow-right'
              iconSize='large32'
              aria-label={showMoreLabel}
              onClick={handleShowMore}
              className={styles.btnShowMore}
            />
          )}
        </div>
      )}
    </div>
  )
}

export default WidgetContainer
